import { CATEGORIES, CategoryKey } from '@common/constants/categories';

interface UseVisibleCategoriesProps {
  isLiteFlow?: boolean;
  categoryKeys?: CategoryKey[];
}

type CategoryEntry = [
  string,
  { name: string; Icon: any; templateId: string; templateLangIds: Record<string, string>; color: string },
];

export const useVisibleCategories = ({
  isLiteFlow = true,
  categoryKeys,
}: UseVisibleCategoriesProps): CategoryEntry[] => {
  if (!isLiteFlow) {
    return Object.entries(CATEGORIES);
  }

  let filteredCategories = Object.entries(CATEGORIES).filter(([key]) => key !== 'rts.chooseForMe');

  if (categoryKeys) {
    filteredCategories = filteredCategories.filter(([key]) => categoryKeys.includes(key as CategoryKey));
  }

  // For dynamic categories, filter out chooseForMe and ensure jewelryAccessories is last
  const jewelryCategory = filteredCategories.find(([key]) => key === 'rts.jewelryAccessories');
  const otherCategories = filteredCategories.filter(([key]) => key !== 'rts.jewelryAccessories');

  return jewelryCategory ? [...otherCategories, jewelryCategory] : filteredCategories;
};
